(function () {
  const viewport = document.querySelector('meta[name="viewport"]');
  function switchViewport() {
    const value = window.outerWidth > 390 ? "width=device-width,initial-scale=1" : "width=390";
    if (viewport.getAttribute("content") !== value) {
      viewport.setAttribute("content", value);
    }
  }
  window.addEventListener("resize", switchViewport, false);
  switchViewport();
})();

document.addEventListener("DOMContentLoaded", function () {
  const menuButton = document.querySelector(".header__sp-hamburger .header__sp-hamburger-menu-button");
  const hamburgerMenu = document.querySelector(".header__sp-hamburger");
  const hamburgerNav = document.querySelector("nav.header__sp-hamburger-nav");
  const hamburgerOpen = document.querySelector(".header__sp-hamburger-menu-text.open");
  const hamburgerClose = document.querySelector(".header__sp-hamburger-menu-text.close");
  const body = document.body;

  if (menuButton && hamburgerMenu && hamburgerNav) {
    menuButton.addEventListener("click", function () {
      const isOpen = hamburgerMenu.classList.toggle("open");
      hamburgerNav.classList.toggle("open", isOpen);
      hamburgerOpen.classList.toggle("is-active");
      hamburgerClose.classList.toggle("is-active");

      if (isOpen) {
        // スクロール位置を固定
        const scrollY = window.scrollY;
        body.dataset.scrollY = scrollY;
        body.style.top = `-${scrollY}px`;
        body.classList.add("no-scroll");
      } else {
        // スクロール位置を解除
        const scrollY = body.dataset.scrollY || "0";
        body.classList.remove("no-scroll");
        body.style.top = "";
        window.scrollTo(0, parseInt(scrollY));
      }
    });

    // アンカーリンクをクリックしたらメニューを閉じる
    const anchorLinks = hamburgerNav.querySelectorAll('a[href*="#"]');
    anchorLinks.forEach(function (link) {
      link.addEventListener("click", function () {
        hamburgerMenu.classList.remove("open");
        hamburgerNav.classList.remove("open");
        const scrollY = body.dataset.scrollY || "0";
        body.classList.remove("no-scroll");
        body.style.top = "";
        window.scrollTo(0, parseInt(scrollY));
      });
    });
  }

  // ハンバーガーメニュー内アコーディオン
  const accordionItems = document.querySelectorAll(".js-accordion");
  accordionItems.forEach((item) => {
    const trigger = item.querySelector(".js-accordion-trigger");
    trigger.addEventListener("click", () => {
      item.classList.toggle("is-expanded");
    });
  });
});

// swiper
if (document.getElementById("js-fv-slider") != null) {
  const swiper = new Swiper("#js-fv-slider", {
    loop: true,
    speed: 3000,
    effect: "fade",
    allowTouchMove: false,
    fadeEffect: {
      crossFade: true,
    },
    autoplay: {
      delay: 5000,
      // マウスオーバー時に自動再生を停止するか
      disableOnInteraction: false,
    },
  });
}

if (document.querySelector(".hospital-introduction-slider") != null) {
  const sliderThumbnail = new Swiper(".hospital-intro-thumb-slider", {
    slidesPerView: 3, // サムネイルの枚数
    centeredSlides: true,
    loop: true,
    spaceBetween: 9, // スライド間のスペース

    breakpoints: {
      768: {
        slidesPerView: 3, // スライドの枚数
        spaceBetween: 25, // スライド間のスペース
      },
    },
  });
  // スライダー
  const slider = new Swiper(".hospital-introduction-slider", {
    loop: true,

    // 前後の矢印
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    slidesPerView: "auto",
    centeredSlides: true,
    thumbs: {
      swiper: sliderThumbnail,
    },
  });

  slider.on("slideChange", function () {
    const activeIndex = slider.realIndex; // 実際のスライドインデックスを取得
    sliderThumbnail.slideToLoop(activeIndex, 300, false); // サムネイルを中央にスクロール
  });
}

document.addEventListener("DOMContentLoaded", function () {
  const tocRoot = document.querySelector(".p-toc");
  const postContent = document.querySelector(".post_content");

  if (!tocRoot || !postContent) return;

  const headings = postContent.querySelectorAll("h2, h3");
  if (headings.length < 2) return;

  // 目次リスト本体の作成（既存がなければ）
  let tocList = tocRoot.querySelector(".p-toc__list");
  if (!tocList) {
    tocList = document.createElement("ol");
    tocList.className = "p-toc__list is-style-index";
    tocList.dataset.level = "2";
    tocRoot.appendChild(tocList);
  }

  tocList.innerHTML = "";

  let currentH2Li = null;
  let indexCount = 0;

  headings.forEach((heading) => {
    const tagName = heading.tagName.toLowerCase();
    const id = `index_id${indexCount++}`;
    heading.id = id;

    const link = document.createElement("a");
    link.href = `#${id}`;
    link.className = "p-toc__link";
    link.textContent = heading.textContent;

    if (tagName === "h2") {
      const li = document.createElement("li");
      li.appendChild(link);
      tocList.appendChild(li);
      currentH2Li = li; // 次のh3はこのh2の子にする
    }

    if (tagName === "h3" && currentH2Li) {
      let childList = currentH2Li.querySelector(".p-toc__childList");
      if (!childList) {
        childList = document.createElement("ol");
        childList.className = "p-toc__childList";
        childList.dataset.level = "3";
        currentH2Li.appendChild(childList);
      }
      const childLi = document.createElement("li");
      childLi.appendChild(link);
      childList.appendChild(childLi);
    }
  });
});
